import React from 'react'
import styled from 'styled-components'

const EmptyVideo = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20;
  font-weight: 700;
  border: 2px solid #a5a5a5;
  background-color: #f5f5f5;
`

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const getYouTubeVideoId = (source) => {
  let ID = ''
  let SOURCE
  SOURCE = source.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  if (SOURCE[2] !== undefined) {
    ID = SOURCE[2].split(/[^0-9a-z_\-]/i)
    ID = ID[0]
  }
  else {
    ID = SOURCE
  }
  return ID
}

const createYouTubeSrc = (videoId, autoplay, loop, controls, showinfo) => {
  return 'https://www.youtube.com/embed/' + videoId +
    '?playlist=' + videoId +
    '&autoplay=' + (
      autoplay ? '1' : '0'
    ) +
    '&loop=' + (
      loop ? '1' : '0'
    ) +
    '&controls=' + (
      controls ? '1' : '0'
    ) +
    '&showinfo=' + (
      showinfo ? '1' : '0'
    )
}

const YoutubePlayer = ({
  content: {
    source = '',
  },
  settings: {
    autoplay = false,
    loop = false,
    controls = false,
    showinfo = false,
  },
  style,
}) => {
  if (!source) {
    return (
      <EmptyVideo>
        วิดีโอว่างเปล่า
      </EmptyVideo>
    )
  }
  const videoId = getYouTubeVideoId(source)
  return (
    <VideoWrapper style={style} className="youtube-element">
      <iframe
        type="text/html"
        src={createYouTubeSrc(videoId, autoplay, loop, controls, showinfo)}
        allowFullScreen
        frameBorder="0"
      >
      </iframe>
    </VideoWrapper>
  )
}

YoutubePlayer.propTypes = {}
YoutubePlayer.defaultProps = {}

export default YoutubePlayer



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/youtube/YoutubePlayer.js